import React from 'react';

import * as analytics from 'analytics/Analytics';
import * as NewUserFlowActions from 'onboarding/new-user-flow/NewUserFlowActions';
import {CALL_TO_ACTION_SCREEN} from 'onboarding/new-user-flow/NewUserFlowConstants';
import JoinOrganizationSearch from 'parties/organizations/JoinOrganizationSearch';
import {useJoinOrganizationSearch} from 'parties/organizations/useJoinOrganizationSearch';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

function NextButton(): JSX.Element {
  return (
    <Button
      className="pull-right u-spacing-top"
      buttonStyle={ButtonStyle.PRIMARY}
      size={ButtonSize.MEDIUM}
      text="Next"
      onClick={() => {
        analytics.track('onboarding_page', 'clicked', {
          page: 'join_organization_page',
          objectClicked: 'button',
          objectText: 'Next',
          eventLastModified: 'FY21_Q1a2',
        });
        NewUserFlowActions.showScreen(CALL_TO_ACTION_SCREEN);
      }}
    />
  );
}

export default function JoinOrganizationPage(): JSX.Element {
  const [
    {query, filters, hasSearched, requestedJoinOrganizationIds},
    {onChangeQuery, onChangeFilters, onChangeRequestedJoinOrganizationIds},
  ] = useJoinOrganizationSearch();
  return (
    <div className="container u-flex-grow">
      <div className="u-text-align-center">
        <h1>Join an Organization</h1>
        <p>Organizations are a great way to collaborate and share results with your team or peers</p>
      </div>
      <Row>
        <Col lg={6} lg-offset={3} md={8} md-offset={2} sm={8} sm-offset={2} xs={8} xs-offset={2}>
          <JoinOrganizationSearch
            query={query}
            onChangeQuery={onChangeQuery}
            requestedJoinOrganizationIds={requestedJoinOrganizationIds}
            onChangeRequestedJoinOrganizationIds={onChangeRequestedJoinOrganizationIds}
            filters={filters}
            setFilters={onChangeFilters}
            hasSearched={hasSearched}
          />
          <NextButton />
        </Col>
      </Row>
    </div>
  );
}
